import { render, staticRenderFns } from "./TextVideo.vue?vue&type=template&id=46b2ff66&scoped=true&"
import script from "./TextVideo.vue?vue&type=script&lang=js&"
export * from "./TextVideo.vue?vue&type=script&lang=js&"
import style0 from "./TextVideo.vue?vue&type=style&index=0&id=46b2ff66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b2ff66",
  null
  
)

export default component.exports